import { Entity, Field } from "typegraph";

import { ID } from "common/entities/IEntity";
import { Tag } from "./Tag";

@Entity({one: "product", many: "products"})
export default class Product {

	@Field()
	public id: ID;

	@Field()
	public name: string;

	@Field()
	public subTitle?: string;

	@Field({entity: Tag})
	public tags?: Tag[];

}



// WEBPACK FOOTER //
// ./src/panels/program/entities/Product.ts